import { useContentAssignmentsPortals, useContentAssignmentsForPortal } from 'academy-common-lib/features/contentAssignments/contentAssignmentsQueries';
import { TABLE_SIZE, useDisplayedData } from '../table';
import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
// @ts-ignore Could not find a declaration file for module
import { useSearchParam } from 'academy-common-lib/hooks/searchParamHooks';
export const useFilteredContentAssignmentsPortals = ({
  contentId,
  contentType,
  page = 1,
  search,
  skip
}) => {
  const [[searchAccounts]] = useSearchParam(FILTER_TYPES.SEARCH_ACCOUNTS);
  const [[assignedBy]] = useSearchParam(FILTER_TYPES.ASSIGNED_BY);
  const query = searchAccounts || search;
  const {
    contentAssignmentsPortals,
    total,
    contentAssignmentsPortalsLoading
  } = useContentAssignmentsPortals({
    contentId,
    contentType,
    offset: (page - 1) * TABLE_SIZE,
    limit: TABLE_SIZE,
    query,
    assignedByRequestingUser: assignedBy === 'ME',
    skip
  });
  const {
    contentAssignmentsPortals: displayedPortals,
    total: displayedTotal
  } = useDisplayedData({
    contentAssignmentsPortals,
    total
  }, {
    loading: contentAssignmentsPortalsLoading
  }) || {};
  const pageCount = displayedTotal && Math.ceil(displayedTotal / TABLE_SIZE) || 1;
  return {
    contentAssignmentsPortals: displayedPortals,
    total: displayedTotal,
    contentAssignmentsPortalsLoading,
    pageCount,
    query
  };
};
export const useFilteredContentAssignmentsForPortal = ({
  contentId,
  contentType,
  portalId,
  page = 1,
  search,
  skip
}) => {
  const [[searchUser]] = useSearchParam(FILTER_TYPES.SEARCH_USER);
  const [[assignedBy]] = useSearchParam(FILTER_TYPES.ASSIGNED_BY);
  const query = searchUser || search;
  const {
    contentAssignmentsForPortal,
    contentAssignmentsForPortalLoading,
    total
  } = useContentAssignmentsForPortal({
    contentId,
    contentType,
    portalId,
    offset: (page - 1) * TABLE_SIZE,
    limit: TABLE_SIZE,
    query,
    assignedByRequestingUser: assignedBy === 'ME',
    skip
  });
  const {
    contentAssignmentsForPortal: displayedAssignmentsForPortal,
    total: displayedTotal
  } = useDisplayedData({
    contentAssignmentsForPortal,
    total
  }, {
    loading: contentAssignmentsForPortalLoading
  }) || {};
  const pageCount = displayedTotal && Math.ceil(displayedTotal / TABLE_SIZE) || 1;
  return {
    contentAssignmentsForPortal: displayedAssignmentsForPortal,
    contentAssignmentsForPortalLoading,
    total: displayedTotal,
    pageCount,
    query
  };
};